import { getNameDisplay } from './Applications';
import './RegistrationStepCount.css';

interface RegistrationStepProps {
    step: number,
    steps: StepName[],
    userType: "customer" | "independent" | "student" | null,
    appId: string | null,
    CONFIG: any
}

export type StepName = "basicInfo" 
    | "facilityInfo" 
    | "instituteInfo" 
    | "customApp" 
    | "confirm"

const stepInfo = {
    "basicInfo": {
        displayName: "Basic Information",
        className:  "a134d6ea-8fb6-4b20-b8d2-d7f96e684f4a"
    },
    "facilityInfo": {
        displayName: "Facility Information",
        className: "45b64a54-03de-4b7b-8e6f-d509b7baa321"
    },
 
    "instituteInfo": {
        displayName: "Institution Information",
        className:  "358a2ea3-5080-4796-9804-3a786a68afdf"
    },
    "confirm": {
        displayName: "Complete Registration",
        className: "a3800404-f513-44ec-a4bd-e68c3c814975"
    },
}

const stepComponent = (stepName: StepName, props: any) => { 
    const appId = props.appId;
    const [appNameDisplay, _] = getNameDisplay(props);
    if (stepName === 'customApp') return appNameDisplay;
    const stepDetails = stepInfo[stepName];   
    return <span className={stepDetails.className}>{stepDetails.displayName}</span>
}
    
const RegistrationStepCount = (props: RegistrationStepProps) => {
    return (
        <div className="col-sm-4 col-md-3">
            <aside className="register" id='registration-steps-container' data-user-type={props.userType}>
                <h4 className="h3-format c6e08adb-97ec-4b0c-a739-cf91fe34e6a9">Registration Steps</h4>
                <ul className="no-bull">
                    <li>1. <span className='f64966de-fb23-4f0a-bd72-2a22b15a2295'>Email Address</span></li>
                    {props.steps.map( (stepName, ind) => 
                        <li className={ind === props.step - 2? "on" : ""}>
                           {ind + 2}. {stepComponent(stepName, props)}
                        </li>
                    )}
                </ul>
            </aside>
        </div>
    )
}

export default RegistrationStepCount
